import { render, staticRenderFns } from "./FreeUserRegistrationPage.vue?vue&type=template&id=81fa66b8"
import script from "./FreeUserRegistrationPage.vue?vue&type=script&lang=js"
export * from "./FreeUserRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports